var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h1", { staticClass: "poll-title poll-title--centered" }, [
      _vm._v(_vm._s(_vm._("Вашу заявку відправлено в обробку")))
    ]),
    _c("p", { staticClass: "poll-text" }, [
      _vm._v(
        _vm._s(
          _vm._(
            "Наш спеціаліст найближчим часом надішле Вам посилку, або зв'яжеться з Вами для уточнень."
          )
        )
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-69471b77", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-69471b77","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/shared/components/poll/steps/success.vue
// module id = 219
// module chunks = 4